import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_loading = _resolveComponent("vue-loading")!
  const _component_Message = _resolveComponent("Message")!
  const _component_AskusNew = _resolveComponent("AskusNew")!

  return (_ctx.loadingAskus)
    ? (_openBlock(), _createBlock(_component_vue_loading, {
        key: 0,
        loadingMessage: "Wird geladen..."
      }))
    : (_ctx.askus.id <= 0 || _ctx.errMessage !== '')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.errMessage !== '')
            ? (_openBlock(), _createBlock(_component_Message, {
                key: 0,
                closable: "",
                class: "mb-2",
                role: "alert",
                severity: "error"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.errMessage), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createVNode(_component_AskusNew, { onOnOpenQuestion: _ctx.openQuestionComponent }, null, 8, ["onOnOpenQuestion"]),
          (_openBlock(), _createBlock(_KeepAlive, null, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComponent.name), {
              askusid: _ctx.currentComponent.askusid,
              question: _ctx.currentComponent?.question,
              onOpenQuestion: _ctx.openQuestionComponent,
              onOpenList: _ctx.openListComponent
            }, null, 8, ["askusid", "question", "onOpenQuestion", "onOpenList"]))
          ], 1024))
        ], 64))
}